import { init, configureScope, captureException } from '@sentry/browser';
import Store from 'repatch';
import State from '../core/State';

class ErrorReporter {
  private store: Store<State>;

  constructor({
    store,
    dsn,
    environment,
    release,
  }: {
    store: Store<State>;
    dsn: string;
    environment: string;
    release: string;
  }) {
    this.store = store;
    init({
      dsn: dsn,
      environment: environment,
      release,
    });
  }

  public reportError = (err: Error) => {
    const state: State = this.store.getState();
    configureScope((scope) => {
      if (state.authentication.signedInUser) {
        scope.setUser({
          id: state.authentication.signedInUser.id,
          username: state.authentication.signedInUser.name,
          email: state.authentication.signedInUser.email,
        });
      }
      scope.setExtras(state);
    });
    captureException(err);
  };
}

export default ErrorReporter;
